var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isActive('operation-get-local-resources'))?_c('popup',{attrs:{"id":"operation-get-local-resources-popup","header-title":`Local resources ${_vm.currentGatewayId}`},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('pre',[_vm._v(_vm._s(_vm.localResources))])]},proxy:true}],null,false,2020276004)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }